import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  listPromotions: [],
};

const promotionsSlice = createSlice({
  name: "promotions",
  initialState,
  reducers: {
    setListPromotions: (state, action) => {
      state.listPromotions = action.payload.listPromotions;
    },
    clearPromotions: (state) => {
      state.listPromotions = [];
    },
  },
});

export const { setListPromotions, clearPromotions } = promotionsSlice.actions;
export default promotionsSlice.reducer;
